import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ContactFormData {
  fullname: string;
  email: string;
  mobile: string;
  message: string;
  company: string;
  recaptchaToken?: string;
}

export interface ContactResponse {
  status: boolean;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private base = environment.apiBaseUrl;

  constructor(private http: HttpClient) { }

  submitContactForm(formData: ContactFormData): Observable<ContactResponse> {
    const url = `${this.base}/SubmitContactUsQuery`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

  return this.http.post<ContactResponse>(url, formData, { headers });
  }
  submitContactFormWithFormData(formData: FormData): Observable<ContactResponse> {
    const url = `${this.base}/SubmitContactUsQuery`;
    return this.http.post<ContactResponse>(url, formData);
  }
}
